import { render, staticRenderFns } from "./viewSearchForm.vue?vue&type=template&id=56f04d0c&scoped=true&"
import script from "./viewSearchForm.vue?vue&type=script&lang=js&"
export * from "./viewSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./viewSearchForm.vue?vue&type=style&index=0&id=56f04d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f04d0c",
  null
  
)

export default component.exports